import { render, staticRenderFns } from "./banner.vue?vue&type=template&id=13f8ec64&scoped=true"
import script from "./banner.vue?vue&type=script&lang=js"
export * from "./banner.vue?vue&type=script&lang=js"
import style0 from "./banner.vue?vue&type=style&index=0&id=13f8ec64&prod&lang=scss&scoped=true"
import style1 from "./banner.vue?vue&type=style&index=1&id=13f8ec64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f8ec64",
  null
  
)

export default component.exports